import { useGetAllSpecialPricesQuery } from "src/api";
import { createTableModule, TableNames } from "src/table";
import type { SpecialPriceListDto } from "src/types";
import { createColumns } from "./createColumns";

export const tableModule = createTableModule<SpecialPriceListDto>(TableNames.allSpecialPrices, useGetAllSpecialPricesQuery, createColumns);
